module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Disclaimer")]), _vm._v(": I’m not an attorney or an accountant. I give advice based on my experiences and successes. I don’t claim anything in this book to be legal advice, estate advice, or tax advice. Please check with your attorney or accountant before using any of the techniques discussed in this book. All investing strategies have inherent risks and should not be taken lightly. Any claims in this book are my results and/or the stated results of students. Your results may differ. Results are not guaranteed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06efab8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 72
// module chunks = 0